import { Routes } from '@angular/router';
import { EnterpriseSubscriptionGuard } from '../security/enterprise-subscription.guard';
import { PermissionGuard } from '../security/permission.guard';
import { app_permissions } from '../security/app-permissions';
import { AuditActionDetailComponent } from './actions/audit-action-detail.component';
import { AuditActionsComponent } from './actions/audit-actions.component';
import { AuditCaseCreateComponent } from './cases/audit-case-create.component';
import { AuditCaseDetailComponent } from './cases/audit-case-detail.component';
import { AuditCasesComponent } from './cases/audit-cases.component';
import { AuditDashboardComponent } from './dashboard/audit-dashboard.component';
import { AuditEvidenceLockerComponent } from './evidence/audit-evidence-locker.component';
import { AuditFindingDetailComponent } from './findings/audit-finding-detail.component';
import { AuditFindingsComponent } from './findings/audit-findings.component';
import { AuditProgramsComponent } from './programs/audit-programs.component';
import { AuditCorrectiveActionReportComponent } from './reports/audit-corrective-action-report.component';
import { AuditOverdueFindingsReportComponent } from './reports/audit-overdue-findings-report.component';
import { AuditRootCauseTrendsReportComponent } from './reports/audit-root-cause-trends-report.component';
import { AuditTemplateDetailComponent } from './templates/audit-template-detail.component';
import { AuditTemplatesComponent } from './templates/audit-templates.component';

const auditSubscriptionData = {
  enterpriseModules: ['AUDIT'],
  enterpriseFeatureLabel: 'LogiLink Audit'
};

export const auditRoutes: Routes = [
  {
    path: 'audit',
    component: AuditDashboardComponent,
    canActivate: [EnterpriseSubscriptionGuard, PermissionGuard],
    data: {
      ...auditSubscriptionData,
      permission: app_permissions.audit.dashboard.view,
      scope: 'ANY'
    }
  },
  {
    path: 'audit/programs',
    component: AuditProgramsComponent,
    canActivate: [EnterpriseSubscriptionGuard, PermissionGuard],
    data: {
      ...auditSubscriptionData,
      permission: app_permissions.audit.programs.view
    }
  },
  {
    path: 'audit/templates',
    component: AuditTemplatesComponent,
    canActivate: [EnterpriseSubscriptionGuard, PermissionGuard],
    data: {
      ...auditSubscriptionData,
      permission: app_permissions.audit.templates.view
    }
  },
  {
    path: 'audit/templates/:id',
    component: AuditTemplateDetailComponent,
    canActivate: [EnterpriseSubscriptionGuard, PermissionGuard],
    data: {
      ...auditSubscriptionData,
      permission: app_permissions.audit.templates.view
    }
  },
  {
    path: 'audit/cases',
    component: AuditCasesComponent,
    canActivate: [EnterpriseSubscriptionGuard, PermissionGuard],
    data: {
      ...auditSubscriptionData,
      permission: app_permissions.audit.cases.view
    }
  },
  {
    path: 'audit/cases/create',
    component: AuditCaseCreateComponent,
    canActivate: [EnterpriseSubscriptionGuard, PermissionGuard],
    data: {
      ...auditSubscriptionData,
      permission: app_permissions.audit.cases.create
    }
  },
  {
    path: 'audit/cases/:id',
    component: AuditCaseDetailComponent,
    canActivate: [EnterpriseSubscriptionGuard, PermissionGuard],
    data: {
      ...auditSubscriptionData,
      permission: app_permissions.audit.cases.view
    }
  },
  {
    path: 'audit/findings',
    component: AuditFindingsComponent,
    canActivate: [EnterpriseSubscriptionGuard, PermissionGuard],
    data: {
      ...auditSubscriptionData,
      permission: app_permissions.audit.findings.view
    }
  },
  {
    path: 'audit/findings/:id',
    component: AuditFindingDetailComponent,
    canActivate: [EnterpriseSubscriptionGuard, PermissionGuard],
    data: {
      ...auditSubscriptionData,
      permission: app_permissions.audit.findings.view
    }
  },
  {
    path: 'audit/actions',
    component: AuditActionsComponent,
    canActivate: [EnterpriseSubscriptionGuard, PermissionGuard],
    data: {
      ...auditSubscriptionData,
      permission: app_permissions.audit.actions.view
    }
  },
  {
    path: 'audit/actions/:id',
    component: AuditActionDetailComponent,
    canActivate: [EnterpriseSubscriptionGuard, PermissionGuard],
    data: {
      ...auditSubscriptionData,
      permission: app_permissions.audit.actions.view
    }
  },
  {
    path: 'audit/evidence',
    component: AuditEvidenceLockerComponent,
    canActivate: [EnterpriseSubscriptionGuard, PermissionGuard],
    data: {
      ...auditSubscriptionData,
      permission: app_permissions.audit.evidence.view
    }
  },
  {
    path: 'audit/reports/corrective-actions',
    component: AuditCorrectiveActionReportComponent,
    canActivate: [EnterpriseSubscriptionGuard, PermissionGuard],
    data: {
      ...auditSubscriptionData,
      permission: app_permissions.audit.reports.view
    }
  },
  {
    path: 'audit/reports/overdue-findings',
    component: AuditOverdueFindingsReportComponent,
    canActivate: [EnterpriseSubscriptionGuard, PermissionGuard],
    data: {
      ...auditSubscriptionData,
      permission: app_permissions.audit.reports.view
    }
  },
  {
    path: 'audit/reports/root-cause-trends',
    component: AuditRootCauseTrendsReportComponent,
    canActivate: [EnterpriseSubscriptionGuard, PermissionGuard],
    data: {
      ...auditSubscriptionData,
      permission: app_permissions.audit.reports.view
    }
  }
];
